//react
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

//data
import dataSiteMap from '../../siteMap.json';

//assets
import './cta.css';

class Cta extends Component {
	jumpToPageTop() {
		document.body.scrollTop = document.documentElement.scrollTop = 0;
	}

	render() {
		const data = this.props.data;
		const culture = this.props.culture;
		const cultureFallback = 'uk'; //UK set as the default culture
		let __htmlTitle = '';
		let body = '';
		let link = '';

		if (data[culture]) {
			if (data[culture].cta) {
				__htmlTitle = data[culture].cta.__htmlTitle;
				body = data[culture].cta.body;
				link = data[culture].cta.link;
			} else if (data[cultureFallback].cta) {
				__htmlTitle = data[cultureFallback].cta.__htmlTitle;
				body = data[cultureFallback].cta.body;
				link = data[cultureFallback].cta.link;
			}
		}

		return (
			<div className="cta">
				<Link className="cta__link cta--materials-colour hwa" hrefLang={dataSiteMap[this.props.culture].cultureCode} onClick={this.jumpToPageTop} to={link}>
					<div className="container__row">
						<div className="container__column container__column--half cta--materials-image">
							<div className="cta__item">
								<div className="cta__item__inner">
									<div className="cta__item__inner__centre-y">
										<div className="cta__item__inner__centre-x">
											<div className="cta__item__inner__text" dangerouslySetInnerHTML={{__html: __htmlTitle}} />
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="container__column container__column--half">
							<div className="cta__link__additional">{body}</div>
						</div>
					</div>
				</Link>
			</div>
		);
	}
}

export default Cta;



// WEBPACK FOOTER //
// ./src/components/cta/cta.js